import { render, staticRenderFns } from "./Awning.vue?vue&type=template&id=31833e48&scoped=true"
import script from "./Awning.vue?vue&type=script&lang=ts"
export * from "./Awning.vue?vue&type=script&lang=ts"
import style0 from "./Awning.vue?vue&type=style&index=0&id=31833e48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31833e48",
  null
  
)

export default component.exports